export const FORMAT_CREATE_AT = 'DD/MM/YYYY';

export const DEFAULT_PAGE = 1;
export const PAGE_SIZE = 10;
